import { useMemo } from "react";
import { Avatar } from "antd";
import { getInitials } from "../../utils/utils";

const UserAvatar = ({ data ,isName = true}) => {

  const colors = [
    { color: "#00727D", bgColor: "#E5F1F2" }, //theme
    { color: "#7367F0", bgColor: "#E9E7FD" }, //purple
    { color: "#00BAD1", bgColor: "#D6F4F8" }, //blue
    { color: "#FF9F43", bgColor: "#FFF0E1" }, // yellow
    { color: "#28C76F", bgColor: "#DDF6E8" }, // green
    { color: "#FF4C51", bgColor: "#FFE2E3" }, // red
  ];

  const randomColor = useMemo(() => {
    if (!data?.profile_image) {
      const index = Math.floor(Math.random() * colors.length);
      return colors[index];
    }
    return null;
  }, [data?.profile_image]);

  if (!data) return null;

  return (
    <div className="flex items-center gap-3">
      <div>
        <Avatar
          size="large"
          src={data?.profile_image}
          className="font-semibold uppercase"
          style={{
            color: !data?.profile_image ? randomColor?.color : "",
            backgroundColor: !data?.profile_image ? randomColor?.bgColor : "",
          }}
        >
          {getInitials(data?.name)}
        </Avatar>
      </div>

     {isName && <div>
        <p className="font-medium text-black">{data?.name}</p>
        <p className="text-Gray">{data?.email}</p>
      </div>
     }
    </div>
  );
};

export default UserAvatar;
